var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"week"},_vm._l((_vm.week),function(day){return _c('event-calendar-day',{key:day.id,staticClass:"day",attrs:{"day":day}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }